import axios from "axios";
import AuthHelper from "@/services/admin/authHelper";
const authHelper = new AuthHelper();

export default class FlightsApi {

  async suggest(term) {
    return await axios.get(`/api/flights/suggest/${term}`);
  }

  async cheapestOne(agencyId, currencyCode, origin, destination, departureDate, returnDate) {
    if (returnDate) {
      return await axios.get(`/api/flights/cheapestOne/${agencyId}/${currencyCode}/${origin}/${destination}/${departureDate}/${returnDate}`);
    }
    return await axios.get(`/api/flights/cheapestOne/${agencyId}/${currencyCode}/${origin}/${destination}/${departureDate}`);
  }

  async search(origin, destination, departureDate, returnDate, adults, children, infants, seatClass, sortOrder, currencyCode, maxResults) {
    if (sortOrder === 'best') {
      sortOrder = 'COMPOSITION';
    }
    else if (sortOrder === 'cheapest') {
      sortOrder = 'PRICE';
    }
    else if (sortOrder === 'quickest') {
      sortOrder = 'TRAVEL_TIME';
    }
    return await axios.post('/api/flights/search', {
      origin: origin,
      destination: destination,
      departureDate: departureDate,
      returnDate: returnDate,
      adults: adults,
      children: children,
      infants: infants,
      seatClass: seatClass,
      sortOrder: sortOrder,
      currencyCode: currencyCode,
      maxResults: maxResults
    });
  }

  async availability(offerToken) {
    return await axios.post('/api/flights/availability', {
      offerToken: offerToken
    });
  }

  async prepareForBook(offerReference, travelers) {
    for(let travelerRef in travelers) {
      delete travelers[travelerRef].type;
    }
    return await axios.post('/api/flights/prepareForBook', {
      offerReference: offerReference,
      travelers: travelers
    });
  }

  async addAncillaries(cartReference, ancillaries) {
    let selectedAncillaries = [];
    for(let i in ancillaries) {

      let ancillary = ancillaries[i];
      let productType = ancillary.productType;

      if (ancillary.productRelation.offer) {
        if (ancillary.productRelation.offer.type === 'SIMPLE' && ancillary.selection !== 0){
          let anc = {type: ancillary.productRelation.offer.type, productType: productType};
          if (ancillary.productRelation.type == 'AIR_PRODUCT') {
            anc.airProductReference = ancillary.productRelation.airProductReference
          }
          selectedAncillaries.push(anc);
        }
        else if (ancillary.productRelation.offer.type === 'TRAVELER') {
          let paxSelection = [];
          // TODO: reconfigure to go through multiple options
          let travelerReferences = ancillary.productRelation.offer.options[0].travelerReferences;
          for(let paxIndex in travelerReferences) {
            let pax = travelerReferences[paxIndex];
            if (pax.selection !== 0) {
              paxSelection.push(pax.travelerReference);
            }
          }
          if (paxSelection.length > 0) {
            let anc = {
              type: ancillary.productRelation.offer.type,
              productType: productType,
              airProductReference: ancillary.productRelation.airProductReference,
              travelerReferences: paxSelection
            };
            selectedAncillaries.push(anc);
          }
        }
        else if (ancillary.productRelation.offer.type === 'TRAVELER_BAGGAGE') {
          let paxSelection = [];
          let travelerReferences = ancillary.productRelation.offer.options[0].travelerReferences;
          for(let paxIndex in travelerReferences) {
            let pax = travelerReferences[paxIndex];
            if (pax.selection !== 0) {
              paxSelection.push(pax.travelerReference);
            }
          }
          if (paxSelection.length > 0) {
            let anc = {
              type: ancillary.productRelation.offer.type,
              productType: productType,
              airProductReference: ancillary.productRelation.airProductReference,
              selectedBaggage: [{
                travelerReferences: paxSelection,
                baggageDetails: {
                  pieces: 1,
                  weight: ancillary.productRelation.offer.options[0].checkedBaggage.maxWeightPerPiece
                }
              }]
            };
            selectedAncillaries.push(anc);
          }

        }
      }
    }

    if (selectedAncillaries.length > 0) {
      return await axios.post('/api/flights/addAncillaries', {
        cartReference: cartReference,
        selectedAncillaries: selectedAncillaries
      });
    }

    return null;
  }

  async bookingSummary(cartReference) {
    return await axios.post('/api/flights/bookingSummary', {
      cartReference: cartReference
    });
  }

  async book(cartReference, paymentInfo) {
    let headers = await authHelper.getAuthHeaders();
    return await axios.post('/api/flights/book', {
      cartReference: cartReference,
      paymentInfo: paymentInfo
    }, {headers});
  }

  async bookContinue(paymentReference, customer, amountToPay, url) {
    let headers = await authHelper.getAuthHeaders();
    return await axios.post('/api/flights/bookContinue', {
      paymentReference: paymentReference,
      customer: customer,
      amountToPay: amountToPay,
      landingUrl: url
    }, {headers});
  }

  async getOrder(orderReference, email) {
    let headers = await authHelper.getAuthHeaders();
    return await axios.post(`/api/orders/flights/${orderReference}/${email}`, {}, {headers});
  }

  async updateOrderServiceFee(orderReference, serviceFee, paid) {
    let headers = await authHelper.getAuthHeaders();
    return await axios.post(`/api/admin/orders/flights/${orderReference}/updateServiceFee`, {
      serviceFee,
      paid
    }, {headers});
  }

  async shareFlightOrderDetailsByEmail(orderReference, email) {
    return await axios.post('/eventBroker', {
      b2b_orderReference: orderReference,
      b2b_eventType: "resend_order_confirmation",
      b2b_emailAddress: email,
      b2b_environmentOrigin:"Production",
      tt_origin: window.TravelPlatform.key
    });
  }

  async sendSupportRequest(orderReference, contactEmail, subject, body) {
    return await axios.post('/eventBroker', {
      b2b_orderReference: orderReference,
      b2b_eventType: "send_support_request",
      b2b_environmentOrigin:"Production",
      request_email: contactEmail,
      request_subject: subject,
      request_body: body,
      tt_origin: window.TravelPlatform.key
    });
  }
}